import React, { useContext } from 'react'
import { Avatar, createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core'
import { StoryContext } from './contexts'
import { useHistory } from 'react-router'

/**
 * The byline on a story.
 *
 * A story submitted from a topic QR card has no account behind it: `userId`,
 * `firstName` and `lastName` are all null and the name came off the form as
 * `authorName`. Two things follow, and neither was true before topic-level
 * submission existed.
 *
 * The name is read through `displayAuthorName`, which falls back to the typed
 * name -- `{firstName} {lastName}` alone would render an empty byline.
 *
 * And the row is only a link when there is a user to link to. It used to
 * navigate unconditionally, which for one of these stories means pushing
 * `/users/null`.
 */
export const StoryAuthor = () => {
  const story = useContext(StoryContext)
  const classes = useStyles()
  const history = useHistory()
  const hasProfile = !!story?.userId
  return (
    <Grid
      container
      className={hasProfile ? classes.profile : undefined}
      onClick={
        hasProfile
          ? (e) => {
              e.preventDefault()
              e.stopPropagation()
              history.push(`/users/${story?.userId}`)
            }
          : undefined
      }
    >
      <Grid item>
        <Avatar className={classes.avatar} src={`${story?.userAvatar?.url}`} />
      </Grid>
      <Grid item>
        <Typography variant='body1'>{story?.displayAuthorName}</Typography>
        {story?.userLocation && story?.userLocation?.trim() !== ',' && <Typography variant='caption'>{story?.userLocation}</Typography>}
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    profile: {
      cursor: 'pointer'
    },
    avatar: {
      margin: '0 .5em .5em 0'
    }
  })
)
